import "./ClientDashboardDesktopComponent.scss";
import {IComponentOptions} from "angular";
import {ClientDashboardModel} from "../models/ClientDashboardModel";

export const ClientDashboardDesktop = "tfClientDashboardDesktop";

export function clientDashboardDesktop(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/desktop/ClientDashboardDesktopComponent.html`,
        bindings: {
            model: "<"
        },
        controllerAs: "ctrl",
        controller: ClientDashboardDesktopComponentController
    };
}

export class ClientDashboardDesktopComponentController {

    public readonly model: ClientDashboardModel;

    public get featuresColumns(): number {
        if (this.model == null) {
            return 4;
        } else if (this.model.showTradingIdeas) {
            return 2;
        } else {
            return 4;
        }
    }
}
